import { render, staticRenderFns } from "./content-group-image.vue?vue&type=template&id=8091fb72&scoped=true"
import script from "./content-group-image.vue?vue&type=script&lang=js"
export * from "./content-group-image.vue?vue&type=script&lang=js"
import style0 from "./content-group-image.vue?vue&type=style&index=0&id=8091fb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8091fb72",
  null
  
)

export default component.exports